<template>
  <div>
    <div v-if="items.length" class="detail-table-wrap">
      <table class="detail-table saidas-table">
        <thead>
          <tr>
            <th>Voucher</th>
            <th>Reserva</th>
            <th>Cliente</th>
            <th>{{ labels.quando }}</th>
            <th>Última edição por</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in items" :key="i.id">
            <td class="voucher-cell">{{ i.voucher }}</td>
            <td class="muted">{{ i.reserva || "—" }}</td>
            <td>{{ i.cliente || "—" }}</td>
            <td class="muted">{{ i.quando || "—" }}</td>
            <td class="muted">{{ i.editor || "—" }}</td>
          </tr>
        </tbody>
        <tfoot v-if="meta.listadas < meta.total">
          <tr>
            <td colspan="5">
              Listando {{ meta.listadas }} de {{ meta.total }}.
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-else class="detail-empty detail-empty--ok">
      <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
      {{ labels.vazio }}
    </div>
  </div>
</template>

<script>
const LABELS = {
  rascunho: {
    quando: "Virou rascunho em",
    vazio: "Nenhuma reserva importada está em rascunho no Phoenix.",
  },
  finalizada: {
    quando: "Finalizada em",
    vazio: "Nenhuma reserva finalizada pela equipe no período.",
  },
  cancelada: {
    quando: "Cancelada em",
    vazio: "Nenhuma reserva cancelada no Phoenix no período.",
  },
};

export default {
  name: "SaidasLista",
  props: {
    items: { type: Array, default: () => [] },
    meta: { type: Object, default: () => ({ total: 0, listadas: 0 }) },
    tipo: { type: String, required: true }, // 'rascunho' | 'finalizada' | 'cancelada'
  },
  computed: {
    labels() {
      return LABELS[this.tipo] || LABELS.rascunho;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../_shared/detail.scss";

.saidas-table {
  min-width: 720px;
  td {
    vertical-align: top;
    word-break: break-word;
  }
  .voucher-cell {
    font-weight: 700;
    color: #384049;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
}
</style>
